import { createSlice } from "@reduxjs/toolkit"

export const initialBreaksState = {
    breaks: [],
    breakDetail: {
        buoys: [],
    },
    pageView: "current",
    allStations: [],
    form: {
        name: "",
        timezone: "PST",
        selectedStations: [],
        notes: "",
        pinned: false, // when rendering list of breaks, make two lists. One for pinned, one for else. Iterate through all with a condition of "if pinned"
        currentStation: "",
        error: "",
    },
    message: null,
    loading: false
}

export const breaksSlice = createSlice({
    name: 'breaks',
    initialState: initialBreaksState,
    reducers: {
        findBuoyPending: (state, action) => {
            state.loading = true
            state.form.error = null
            state.message = null
        },
        findBuoyFailure: (state, action) => {
            state.loading = false
            state.form.error = "Could not find that station"
            state.message = null
            state.currentStation = null
        },
        findBuoySuccess: (state, action) => {
            state.loading = false
            state.form.error = null
            state.message = null
            state.currentStation = action.payload.currentStation
        },
        fetchAllSuccess: (state, action) => {
            state.loading = false
            state.form.error = null
            state.message = null
            state.allStations = action.payload.allStations
        },
        fetchAllFailure: (state, action) => {
            state.loading = false
            state.form.error = action.payload.error
            state.message = null
            state.allStations = []
        },
        formName: (state, action) => {
            state.form.name = action.payload
        },
        formBuoy: (state, action) => {
            state.form.currentStation = action.payload
        },
        setFormBuoys: (state, action) => {
            state.form.selectedStations = action.payload
        },
        formTime: (state, action) => {
            state.form.timezone = action.payload;
        },
        addBuoySuccess: (state, action) => {
            state.form.selectedStations.push(action.payload)
            state.form.currentStation = ""
            state.form.error = null
        },
        addBuoyFailure: (state, action) => {
            state.currentStation = null
            state.form.error = "Couldn't find that buoy! Make sure to choose one from the list"
        },
        removeBuoy: (state, action) => {
            state.form.selectedStations = action.payload
        },
        createBreakFailure: (state, action) => {
            state.loading = false
            state.form.error = action.payload.error
        },
        createBreakSuccess: (state) => {
            state.loading = false
            state = initialBreaksState
        },
        getAllBreaks: (state, action) => {
            state.breaks = action.payload
            state.loading = false
        },
        getBreak: (state, action) => {
            state.breakDetail = action.payload
            state.loading = false
        },
        changePageView: (state, action) => {
            state.pageView = action.payload;
        },
        updateBreak: (state, action) => {
            state.breakDetail = action.payload;
            state.loading = false
        },
        setBreakLoading: (state) => {
            state.loading = true;
        }
    }
})

export const {
    findBuoyPending,
    findBuoyFailure,
    findBuoySuccess,
    fetchAllFailure,
    fetchAllSuccess,
    formName,
    formBuoy,
    setFormBuoys,
    formTime,
    addBuoySuccess,
    addBuoyFailure,
    removeBuoy,
    createBreakFailure,
    createBreakSuccess,
    getAllBreaks,
    getBreak,
    changePageView,
    updateBreak,
    setBreakLoading
} = breaksSlice.actions

export default breaksSlice.reducer;